export const applyAcrylicEffect = async (canvas, ctx, setMessage, language) => {
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 아크릴 효과: 선명하고 평면적인 색감
  // 1. 색상 평면화 (아크릴의 매트한 질감)
  for (let i = 0; i < data.length; i += 4) {
    // 색상 양자화 (레벨 감소)
    const levels = 6; // 색상 레벨 수
    data[i] = Math.round(data[i] / (255 / levels)) * (255 / levels);
    data[i + 1] = Math.round(data[i + 1] / (255 / levels)) * (255 / levels);
    data[i + 2] = Math.round(data[i + 2] / (255 / levels)) * (255 / levels);
    
    // 채도 증가 (아크릴의 선명한 색감)
    const avg = (data[i] + data[i + 1] + data[i + 2]) / 3;
    data[i] = Math.min(255, avg + (data[i] - avg) * 1.2);
    data[i + 1] = Math.min(255, avg + (data[i + 1] - avg) * 1.2);
    data[i + 2] = Math.min(255, avg + (data[i + 2] - avg) * 1.2);
  }
  
  ctx.putImageData(imageData, 0, 0);
  
  // 2. 엣지 강조 (아크릴 페인팅의 명확한 경계선)
  const tempCanvas = document.createElement('canvas');
  tempCanvas.width = canvas.width;
  tempCanvas.height = canvas.height;
  const tempCtx = tempCanvas.getContext('2d');
  tempCtx.drawImage(canvas, 0, 0);
  
  const edgeData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const edgePixels = edgeData.data;
  const tempData = tempCtx.getImageData(0, 0, canvas.width, canvas.height).data;
  
  // 소벨 엣지 검출 필터 적용
  for (let y = 1; y < canvas.height - 1; y++) {
    for (let x = 1; x < canvas.width - 1; x++) {
      const pos = (y * canvas.width + x) * 4;
      
      for (let c = 0; c < 3; c++) {
        // 소벨 X 필터
        const sobelX = 
          -1 * tempData[((y - 1) * canvas.width + (x - 1)) * 4 + c] +
           1 * tempData[((y - 1) * canvas.width + (x + 1)) * 4 + c] +
          -2 * tempData[(y * canvas.width + (x - 1)) * 4 + c] +
           2 * tempData[(y * canvas.width + (x + 1)) * 4 + c] +
          -1 * tempData[((y + 1) * canvas.width + (x - 1)) * 4 + c] +
           1 * tempData[((y + 1) * canvas.width + (x + 1)) * 4 + c];
        
        // 소벨 Y 필터
        const sobelY = 
          -1 * tempData[((y - 1) * canvas.width + (x - 1)) * 4 + c] +
          -2 * tempData[((y - 1) * canvas.width + x) * 4 + c] +
          -1 * tempData[((y - 1) * canvas.width + (x + 1)) * 4 + c] +
           1 * tempData[((y + 1) * canvas.width + (x - 1)) * 4 + c] +
           2 * tempData[((y + 1) * canvas.width + x) * 4 + c] +
           1 * tempData[((y + 1) * canvas.width + (x + 1)) * 4 + c];
        
        const magnitude = Math.sqrt(sobelX * sobelX + sobelY * sobelY);
        
        // 엣지가 강한 부분은 더 선명하게
        if (magnitude > 30) {
          edgePixels[pos + c] = Math.min(255, tempData[pos + c] * 1.1);
        } else {
          edgePixels[pos + c] = tempData[pos + c];
        }
      }
    }
  }
  
  ctx.putImageData(edgeData, 0, 0);
  
  // 3. 매트 질감 추가
  const matteData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const mattePixels = matteData.data;
  
  for (let i = 0; i < mattePixels.length; i += 4) {
    // 약간의 매트 효과 (반사 감소)
    for (let c = 0; c < 3; c++) {
      mattePixels[i + c] = Math.min(255, mattePixels[i + c] * 0.95 + 10);
    }
  }
  
  ctx.putImageData(matteData, 0, 0);
};